import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, map, Observable } from 'rxjs';
import { Subject } from 'rxjs';
import { EncryptionService } from './encryption';
import { SETTINGS } from '../config/common.settings';

export interface Subscriber {
  _id: string;
  refNo?: string;
  companyName: string;
  firstName: string;
  lastName: string;
  email: string;
  status: string;
  companyLogo: string;
  termsConditions: string;
  privacyPolicy: string;
  industries: string[];
  operationalRegions: string[];
  contactDuration: string;
  contractDurationsList: string[];
  language: string;
  createdAt?: string;
  updatedAt?: string;
  user?: {
    _id: string;
    firstName: string;
    lastName: string;
    email: string;
    isActive: boolean;
  };
}

export interface PagedSubscriberResponse {
  message: string;
  data: Subscriber[];
  metadata: Array<{
    total: number;
    page: number;
  }>;
}

export interface PagedSubscriberRequest {
  pageIndex: number;
  pageSize: number;
  sortField?: string;
  sortOrder?: 1 | -1;
  filters?: {
    searchText?: string;
    status?: string;
    userStatus?: boolean;
    industries?: string[];
    operationalRegions?: string[];
  };
}


@Injectable({
  providedIn: 'root',
})
export class SubscriberService {
  subscriber: any;
  subscriberChange: any = {};
  onsubscriberChange: Subject<any> = new BehaviorSubject({});
  onSubscriberPaymentChange: Subject<any> = new BehaviorSubject({});

  constructor(private http: HttpClient, private encryption: EncryptionService) { }

  // Get paged subscriber with advanced filtering
  getPagedSubscriber(params: PagedSubscriberRequest): Observable<PagedSubscriberResponse> {
    return this.http.post<{ message: string, data: Subscriber[], metadata: Array<{ total: number, page: number }> }>(`${environment.apiUrl}/subscribers/paged`, params).pipe(
      map(response => ({
        message: response.message,
        data: response.data || [],
        metadata: response.metadata || []
      }))
    );
  }

  createSubscriber(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .post(`${environment.apiUrl}/subscribers`, payload)
        .subscribe({
          next: (response: any) => {
            this.subscriber = response;
            resolve(this.subscriber);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }


  getAllSubscribers(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/subscribers`);
}

  getAllSubscribersForSelector(): Observable<any> {
    return this.http.get(`${environment.apiUrl}/subscribers/selector`);
}

  updateSubscriber(payload: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const { _id, ...updateData } = payload;
      this.http
        .put(`${environment.apiUrl}/subscribers/${_id}`, updateData)
        .subscribe({
          next: (response: any) => {
            this.subscriber = response.subscriber;
            resolve(this.subscriber);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  findSubscriber(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/subscribers/${id}`)
        .subscribe({
          next: (response: any) => {
            this.subscriber = response;
            this.subscriberChange = response;
            this.onsubscriberChange.next(this.subscriberChange);
            resolve(this.subscriber);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  findSubscriberPayment(id: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${environment.apiUrl}/subscribers/${id}`)
        .subscribe({
          next: (response: any) => {
            const { isPaid } = response;
            this.subscriber = response;
            // this.setPInfo(JSON.stringify(isPaid));
            resolve(this.subscriber);
          },
          error: (error: any) => {
            reject(error);
          },
        });
    });
  }

  setPInfo(userStr: any): void {
    localStorage.setItem(
      SETTINGS.PAYMENT,
      this.encryption.encrypt(userStr)
    );
  }

  getPInfo(): any {
    const userStrEnc: any = localStorage.getItem(SETTINGS.PAYMENT);
    return JSON.parse(this.encryption.decrypt(userStrEnc));
  }
}

